import { InputContext } from "./chunk-GBSFMBQH.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Input/Input.tsx
import { useMemo } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var INPUT_CLASSNAME_MAP = {
  variant: {
    primary: "pd:input--primary",
    secondary: ""
  },
  validation: {
    error: "pd:input--error",
    success: "pd:input--success",
    warning: "pd:input--warning",
    info: "pd:input--info",
    dim: "pd:input--dim"
  }
};
var Input = _a => {
  var _b = _a,
    {
      children,
      variant = "secondary",
      validation,
      disabled,
      className
    } = _b,
    rest = __objRest(_b, ["children", "variant", "validation", "disabled", "className"]);
  const context = useMemo(() => ({
    disabled,
    validation
  }), [disabled, validation]);
  return /* @__PURE__ */jsx(InputContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
      className: clsx("pd:input", INPUT_CLASSNAME_MAP.variant[variant], validation && INPUT_CLASSNAME_MAP.validation[validation], disabled && "pd:input--disabled", className)
    }, rest), {
      children
    }))
  });
};
var Input_default = Input;
export { INPUT_CLASSNAME_MAP, Input_default };